module.exports = __webpack_public_path__ + "static/Cibee_Kamara-ada7d5c17944efe8e75689c45c48ba07.webp";